import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height", "viewBox"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_11969_41417)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M9.38303 6.19782C9.31117 6.12736 9.22021 6.07954 9.12143 6.06029C9.02265 6.04104 8.92039 6.05121 8.82733 6.08953C8.73427 6.12784 8.6545 6.19263 8.59791 6.27586C8.54133 6.35908 8.51041 6.45709 8.509 6.55772L8.509 8.24923C8.509 8.28332 8.49546 8.31602 8.47135 8.34012C8.44725 8.36423 8.41455 8.37777 8.38046 8.37777L1.41388 8.37777C1.37979 8.37777 1.3471 8.36422 1.323 8.34012C1.29889 8.31602 1.28535 8.28332 1.28535 8.24923L1.28535 1.43432C1.28535 1.26388 1.21764 1.10041 1.09711 0.979884C0.97659 0.85936 0.813123 0.79165 0.642675 0.79165C0.472228 0.79165 0.308762 0.85936 0.188237 0.979884C0.0677128 1.10041 1.89226e-06 1.26388 1.87736e-06 1.43432L1.21416e-06 9.02044C1.19925e-06 9.19089 0.0677121 9.35435 0.188236 9.47488C0.308761 9.5954 0.472227 9.66311 0.642675 9.66311L8.35476 9.66311C8.38844 9.66439 8.4204 9.67834 8.44423 9.70217C8.46807 9.72601 8.48202 9.75797 8.48329 9.79165L8.48329 11.4883C8.48337 11.5892 8.51315 11.6879 8.56892 11.772C8.62469 11.8561 8.70399 11.922 8.79692 11.9613C8.89103 12 8.99453 12.01 9.09429 11.9898C9.19406 11.9697 9.2856 11.9204 9.35733 11.8482L11.8458 9.38548C11.8943 9.33786 11.933 9.28108 11.9595 9.21842C11.9859 9.15576 11.9997 9.08847 12 9.02044C11.9981 8.88483 11.9426 8.75547 11.8458 8.66054L9.38303 6.19782Z",
    fill: "#DBDBDB"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_41417" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white",
      transform: "translate(12 12) rotate(-180)"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'enterIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#DBDBDB",
  },
  size: {
    type: Number as PropType<number>,
    default: 12,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: __props.size,
    height: __props.size,
    viewBox: `0 0 ${__props.size} ${__props.size}`,
    fill: "none"
  }, _hoisted_4, 8, _hoisted_1))
}
}

})